import React, { useRef } from 'react';
import { ReportBody } from './ReportBody';
import { ReportContextProvider } from '../Context/ReportContext';
export const Report = ({
  reportHeader,
  reporting,
  agency
}) => {
  const gridAPIRef = useRef(null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ReportContextProvider, {
    reporting: reporting,
    agency: agency,
    reportHeader: reportHeader,
    gridAPIRef: gridAPIRef
  }, /*#__PURE__*/React.createElement(ReportBody, {
    reportHeader: reportHeader,
    gridAPIRef: gridAPIRef
  })));
};